import React from 'react'

const MissionVision = () => {
    return (
        <>
            <section className="program-section section-padding pt-0 fix" style={{marginTop:"-40px"}}>
                <div className="container">
                    <div className="row g-4">
                      
                        <div className="col-xl-6 col-lg-4 col-md-6 col-sm-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <div className="program-box-item">
                                <div className="top-bar">
                                    <img src="assets/img/program/top-2.png" alt="icon-image" />
                                </div>
                                <div className="bottom-bar">
                                    <img src="assets/img/program/bottom-2.png" alt="icon-image" />
                                </div>
                                <div className="program-bg bg-2" />
                                <div className="program-icon">
                                    <img src="assets/sa/mission.png" alt="icon-image" style={{ height: "170px", width: "200px" }} />
                                </div>
                                <div className="program-content" style={{marginTop:"-40px"}}>
                                    {/* <h3>Preschool</h3> */}
                                    <p>Our mission is to provide high-quality education and practical knowledge that helps students achieve their academic and career goals.</p>
                                </div>
                            </div>
                        </div>
                       
                        <div className="col-xl-6 col-lg-4 col-md-6 col-sm-6 wow fadeInUp" data-wow-delay=".8s" style={{ visibility: 'visible', animationDelay: '0.8s', animationName: 'fadeInUp' }}>
                            <div className="program-box-item">
                                <div className="top-bar">
                                    <img src="assets/img/program/top-4.png" alt="icon-image" />
                                </div>
                                <div className="bottom-bar">
                                    <img src="assets/img/program/bottom-4.png" alt="icon-image" />
                                </div>
                                <div className="program-bg bg-4" />
                                <div className="program-icon">
                                    <img src="assets/sa/vision.png" alt="icon-image" style={{ height: "180px", width: "180px" }} />
                                </div>
                                <div className="program-content" style={{marginTop:"-30px"}}>
                                    {/* <h3>Pre-K Program</h3> */}
                                    <p>Our vision is to become a leading educational academy known for excellence, innovation, and student success.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default MissionVision